var _ellipse, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssueOther({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    "data-svg-class": "icon-stroke",
    cx: 16.6243,
    cy: 28.2537,
    rx: 3.90698,
    ry: 3.90698,
    stroke: "#BBC0CF",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "icon-stroke",
    cx: 28.345,
    cy: 28.2537,
    r: 3.90698,
    stroke: "#BBC0CF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "icon-stroke",
    cx: 40.0662,
    cy: 28.2537,
    r: 3.90698,
    stroke: "#BBC0CF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueOther);
export default __webpack_public_path__ + "static/media/IssueOther.7ba7a99cacb4cb9113c93abef549e6ef.svg";
export { ForwardRef as ReactComponent };